import React, { Component } from 'react';
import AppSidebar from "../components/AppSidebar";
import PageHeader from "../components/PageHeader";
import ActionButton from "../components/ActionButton";
import PanelGroupController from "../components/PanelGroupController";
import FilterPanel from "../components/panels/FilterPanel";
import DistributionList from "./views/DistributionList";
import {List, fromJS} from "immutable";
import "./DistributionPage.css";

const filterOptions = fromJS([
  {id: "countries", label: "Countries"},
  {id: "us-states", label: "US States"},
  {id: "ca-provinces", label: "Canada Provinces"},
])

class DistributionPage extends Component {

  constructor(props) {
    super(props);
    this.handleSetSelection = this.handleSetSelection.bind(this);
    this.handleSetFilter = this.handleSetFilter.bind(this);
    this.handleAssignWarehouse = this.handleAssignWarehouse.bind(this);
    this.state = {
      selectedItem: null,
      selectedId: "",
      selectedKind: "",
      hasSelection: false,
      filter: "countries"
    }
  }


  render() {
    const page = this.props.route.page;
    let view = this.renderView(page);
    let panels = this.renderPanels(page);

    let title = "Distribution";

    return (
      <div className="ShippingPage DistributionPage SecurePage">
        <AppSidebar />
        <PageHeader title={title} />
        <div className="PageContainer">
          {view}
        </div>
        <div className="PanelContainer">
          <div className="header" />
          {panels}
          <PanelGroupController title="Actions">
            <ActionButton 
              label="Assign warehouse" 
              active={this.state.hasSelection}
              onClick={this.handleAssignWarehouse}
              />
          </PanelGroupController>
        </div>
      </div>
    );
  }

  renderView(page) {
    switch(page) {
      default: 
        return <DistributionList
                key="DistributionList"
                kind={this.state.filter}
                selectedId={this.state.selectedId}
                onSelectionChange={this.handleSetSelection}
                />
    }
  }


  renderPanels(page) {
    switch(page) {
      default:
        return this.buildPanels(List([FilterPanel]));
    }
  }

  buildPanels(panels) {
    return panels.map(x => this.buildPanel(x));
  }

  buildPanel(component) {
    switch(component) {
      case FilterPanel:
        return <FilterPanel
          key="FilterPanel"
          expanded={true}
          options={filterOptions}
          onClick={this.handleSetFilter}
          filter={this.state.filter}
          />        
      default:
        return null;
    }
  }

  handleSetFilter(item) {
    this.setState({
      filter: item.get("id"),
      selectedItem: null,
      hasSelection: false,
      selectedId: "",
      selectedKind: ""      
    });
  }

  handleSetSelection(item) {
    this.setState({
      selectedItem: item,
      hasSelection: true,
      selectedId: item.get("code"),
      selectedKind: item.get("kind")
    })
  }

  handleAssignWarehouse() {
    let item = this.state.selectedItem;
    this.props.requestAssignWarehouseToLocation(
      item.get("kind"),
      item.get("code"),
      item.get("name"),
      item.get("warehouseId")
    );
  }

}

export default DistributionPage;